export const easterSaleProductS = {
    mainPromoHeadline:
      "products.product.promotions.easterSale.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.easterSale.heading.image",
      title: "products.productS.promotions.easterSale.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productS.promotions.easterSale.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productS.promotions.easterSale.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productS.promotions.easterSale.footer",
    total: {
      headline: "products.productS.promotions.easterSale.total.headline",
      priceBefore: "products.productS.promotions.easterSale.total.priceBefore",
      priceAfter: "products.productS.promotions.easterSale.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.easterSale.discount.heading",
      title: "products.productS.promotions.easterSale.discount.title",
      amount: "products.productS.promotions.easterSale.discount.amount",
      code: {
        description:
          "products.productS.promotions.easterSale.discount.code.description",
        promoCode:
          "products.productS.promotions.easterSale.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productS.promotions.easterSale.items.item1.title",
        description:
          "products.productS.promotions.easterSale.items.item1.description",
        priceBefore:
          "products.productS.promotions.easterSale.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.easterSale.items.item1.priceAfter",
      },
      item2: {
        title: "products.productS.promotions.easterSale.items.item2.title",
        description:
          "products.productS.promotions.easterSale.items.item2.description",
        priceBefore:
          "products.productS.promotions.easterSale.items.item2.priceBefore",
        priceAfter: "products.productS.promotions.easterSale.items.item2.priceAfter",
      },
      item3: {
        title: "products.productS.promotions.easterSale.items.item3.title",
        description:
          "products.productS.promotions.easterSale.items.item3.description",
        priceBefore:
          "products.productS.promotions.easterSale.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.easterSale.items.item3.priceAfter",
      },
      item4: {
        title: "products.productS.promotions.easterSale.items.item4.title",
        description:
          "products.productS.promotions.easterSale.items.item4.description",
        priceBefore:
          "products.productS.promotions.easterSale.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.easterSale.items.item4.priceAfter",
      },
      item5: {
        title: "products.productS.promotions.easterSale.items.item5.title",
        description:
          "products.productS.promotions.easterSale.items.item5.description",
        priceBefore:
          "products.productS.promotions.easterSale.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.easterSale.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateEasterSaleProductS = {
    mainPromoHeadline:
      "products.productS.promotions.flatrateEasterSale.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.flatrateEasterSale.heading.image",
      title: "products.productS.promotions.flatrateEasterSale.heading.title",
    },
    footer: "products.productS.promotions.flatrateEasterSale.footer",
    total: {
      headline:
        "products.productS.promotions.flatrateEasterSale.total.headline",
      priceBefore:
        "products.productS.promotions.flatrateEasterSale.total.priceBefore",
      priceAfter:
        "products.productS.promotions.flatrateEasterSale.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.easterSale.discount.heading",
      title: "products.productS.promotions.flatrateEasterSale.discount.title",
      amount: "products.productS.promotions.flatrateEasterSale.discount.amount",
      code: {
        description:
          "products.productS.promotions.flatrateEasterSale.discount.code.description",
        promoCode:
          "products.productS.promotions.flatrateEasterSale.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productS.promotions.flatrateEasterSale.items.item1.title",
        description:
          "products.productS.promotions.flatrateEasterSale.items.item1.description",
        priceBefore:
          "products.productS.promotions.flatrateEasterSale.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateEasterSale.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productS.promotions.flatrateEasterSale.items.item2.title",
        description:
          "products.productS.promotions.flatrateEasterSale.items.item2.description",
        priceBefore:
          "products.productS.promotions.flatrateEasterSale.items.item2.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateEasterSale.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productS.promotions.flatrateEasterSale.items.item3.title",
        description:
          "products.productS.promotions.flatrateEasterSale.items.item3.description",
        priceBefore:
          "products.productS.promotions.flatrateEasterSale.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateEasterSale.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productS.promotions.flatrateEasterSale.items.item4.title",
        description:
          "products.productS.promotions.flatrateEasterSale.items.item4.description",
        priceBefore:
          "products.productS.promotions.flatrateEasterSale.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateEasterSale.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productS.promotions.flatrateEasterSale.items.item5.title",
        description:
          "products.productS.promotions.flatrateEasterSale.items.item5.description",
        priceBefore:
          "products.productS.promotions.flatrateEasterSale.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateEasterSale.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productS.promotions.flatrateEasterSale.items.item6.title",
        description:
          "products.productS.promotions.flatrateEasterSale.items.item6.description",
        priceBefore:
          "products.productS.promotions.flatrateEasterSale.items.item6.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateEasterSale.items.item6.priceAfter",
      },
    },
  };
  
  export const easterSaleProductX = {
    mainPromoHeadline:
      "products.productX.promotions.easterSale.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.easterSale.heading.image",
      title: "products.productX.promotions.easterSale.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productX.promotions.easterSale.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productX.promotions.easterSale.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productX.promotions.easterSale.footer",
    total: {
      headline: "products.productX.promotions.easterSale.total.headline",
      priceBefore: "products.productX.promotions.easterSale.total.priceBefore",
      priceAfter: "products.productX.promotions.easterSale.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.easterSale.discount.heading",
      title: "products.productX.promotions.easterSale.discount.title",
      amount: "products.productX.promotions.easterSale.discount.amount",
      code: {
        description:
          "products.productX.promotions.easterSale.discount.code.description",
        promoCode:
          "products.productX.promotions.easterSale.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productX.promotions.easterSale.items.item1.title",
        description:
          "products.productX.promotions.easterSale.items.item1.description",
        priceBefore:
          "products.productX.promotions.easterSale.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.easterSale.items.item1.priceAfter",
      },
      item2: {
        title: "products.productX.promotions.easterSale.items.item2.title",
        description:
          "products.productX.promotions.easterSale.items.item2.description",
        priceBefore:
          "products.productX.promotions.easterSale.items.item2.priceBefore",
        priceAfter: "products.productX.promotions.easterSale.items.item2.priceAfter",
      },
      item3: {
        title: "products.productX.promotions.easterSale.items.item3.title",
        description:
          "products.productX.promotions.easterSale.items.item3.description",
        priceBefore:
          "products.productX.promotions.easterSale.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.easterSale.items.item3.priceAfter",
      },
      item4: {
        title: "products.productX.promotions.easterSale.items.item4.title",
        description:
          "products.productX.promotions.easterSale.items.item4.description",
        priceBefore:
          "products.productX.promotions.easterSale.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.easterSale.items.item4.priceAfter",
      },
      item5: {
        title: "products.productX.promotions.easterSale.items.item5.title",
        description:
          "products.productX.promotions.easterSale.items.item5.description",
        priceBefore:
          "products.productX.promotions.easterSale.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.easterSale.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateEasterSaleProductX = {
    mainPromoHeadline:
      "products.productX.promotions.flatrateEasterSale.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.flatrateEasterSale.heading.image",
      title: "products.productX.promotions.flatrateEasterSale.heading.title",
    },
    footer: "products.productX.promotions.flatrateEasterSale.footer",
    total: {
      headline:
        "products.productX.promotions.flatrateEasterSale.total.headline",
      priceBefore:
        "products.productX.promotions.flatrateEasterSale.total.priceBefore",
      priceAfter:
        "products.productX.promotions.flatrateEasterSale.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.easterSale.discount.heading",
      title: "products.productX.promotions.flatrateEasterSale.discount.title",
      amount: "products.productX.promotions.flatrateEasterSale.discount.amount",
      code: {
        description:
          "products.productX.promotions.flatrateEasterSale.discount.code.description",
        promoCode:
          "products.productX.promotions.flatrateEasterSale.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productX.promotions.flatrateEasterSale.items.item1.title",
        description:
          "products.productX.promotions.flatrateEasterSale.items.item1.description",
        priceBefore:
          "products.productX.promotions.flatrateEasterSale.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateEasterSale.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productX.promotions.flatrateEasterSale.items.item2.title",
        description:
          "products.productX.promotions.flatrateEasterSale.items.item2.description",
        priceBefore:
          "products.productX.promotions.flatrateEasterSale.items.item2.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateEasterSale.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productX.promotions.flatrateEasterSale.items.item3.title",
        description:
          "products.productX.promotions.flatrateEasterSale.items.item3.description",
        priceBefore:
          "products.productX.promotions.flatrateEasterSale.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateEasterSale.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productX.promotions.flatrateEasterSale.items.item4.title",
        description:
          "products.productX.promotions.flatrateEasterSale.items.item4.description",
        priceBefore:
          "products.productX.promotions.flatrateEasterSale.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateEasterSale.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productX.promotions.flatrateEasterSale.items.item5.title",
        description:
          "products.productX.promotions.flatrateEasterSale.items.item5.description",
        priceBefore:
          "products.productX.promotions.flatrateEasterSale.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateEasterSale.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productX.promotions.flatrateEasterSale.items.item6.title",
        description:
          "products.productX.promotions.flatrateEasterSale.items.item6.description",
        priceBefore:
          "products.productX.promotions.flatrateEasterSale.items.item6.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateEasterSale.items.item6.priceAfter",
      },
    },
  };
  